export default __webpack_public_path__ + "static/O0157-020bcdfd2f76544eec796294006974fd.png";